import { useRef } from 'react';

export type fullScreenSpinnerProps = {
  showSpinner: boolean;
};

export default function FullScreenSpinner({ showSpinner }: fullScreenSpinnerProps) {
  const modalRef = useRef<HTMLDivElement>(null);

  const MODAL_OPEN_CLASS = 'fullscreen-spinner-modal-open';

  return (
    <>
      <div className={`fullscreen-spinner-modal ${showSpinner ? MODAL_OPEN_CLASS : ''}`} ref={modalRef}>
        <div className="fullscreen-spinner-loader"></div>
      </div>
    </>
  );
}
